import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../TierProductCardDumb/utils';

import s from './TierPricePerMonth.scss';

export interface Props {
  price?: string;
  className?: string;
}

/* {price}/month typography */
const TierPricePerMonth: React.FC<Props> = ({ price, className }) => {
  const { t } = useTranslation();
  return (
    <span className={classnames(s['root'], className)}>
      <span className={s['price']}>{formatPrice(price)}</span>
      <span className={s['period']}>/{t('deviationview.tierCard.pricePeriod.month')}</span>
    </span>
  );
};
TierPricePerMonth.displayName = 'TierPricePerMonth';

export default TierPricePerMonth;
